// UTILITIES
import whitelistKeys from '../../../../../utils/whitelistKeysUTL';
import loggerUTL from '../../../../../utils/loggerUTL';

const whitelistedInputDataFR = (inputData, dataSources) => {
  let franceResidential, franceResidential2, franceResidential3, watchlistData;

  /* ============================================
              France Residential
   ============================================ */
  if (dataSources.includes('France Residential')) {
    loggerUTL('WHITELISTING...');
    const whitelisted = whitelistKeys(inputData, [
      'firstName',
      'lastName',
      'dateOfBirth',
      'streetAddress',
      'city',
      'postCode',
      'reportingReference',
    ]);

    franceResidential = { ...whitelisted };
  }

  /* ============================================
              France Residential 2
  ============================================ */
  if (dataSources.includes('France Residential 2')) {
    loggerUTL('WHITELISTING...');
    const whitelisted = whitelistKeys(inputData, [
      'firstName',
      'lastName',
      'streetAddress',
      'city',
      'state',
      'postCode',
      'emailAddress',
      'phoneNo',
      'reportingReference',
    ]);
    franceResidential2 = { ...whitelisted };
  }

    /* ============================================
              France Residential 3
  ============================================ */
  if (dataSources.includes('France Residential 3')) {
    loggerUTL('WHITELISTING...');
    const whitelisted = whitelistKeys(inputData, [
      'firstName',
      'lastName',
      'dateOfBirth',
      'streetAddress',
      'city',
      'postCode',
      'emailAddress',
      'phoneNo',
      'reportingReference',
    ]);
    franceResidential3 = { ...whitelisted };
  }

  /* ============================================
              WATCHLIST AML
   ============================================ */
  if (dataSources.includes('Watchlist AML')) {
    loggerUTL('WHITELISTING WATCHLIST AML...');
    const whitelisted = whitelistKeys(inputData, [
      'firstName',
      'lastName',
      'dateOfBirth',
      'gender',
      'reportingReference',
    ]);
    watchlistData = { ...whitelisted };
  }

  return {
    ...franceResidential,
    ...franceResidential2,
    ...franceResidential3,
    ...watchlistData,
  };
};
export default whitelistedInputDataFR;
